// helpers
import isFeatureEnabled from "shared/featureflags/helperFunctions"
import { checkPermission, permissionFilter } from "shared/imports/permissionFunctions"
import { getSearchPath, getCurrentWebSearchOptions } from "search-new/routes"
import { aiSearchExamples } from "shared/search/constants"

// blatantly copied from stackoverflow's "how to randomize shuffle
// a javascript array"
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
    }
    return array
}

// taken and adapated from imports/searchPlaceholders.coffee
export const generatePlaceholders = () => {
    let quorumDataTypes = [
        DjangIO.app.models.QuorumDataType.person,
        DjangIO.app.models.QuorumDataType.bill,
        DjangIO.app.models.QuorumDataType.vote,
        DjangIO.app.models.QuorumDataType.staffer,
        DjangIO.app.models.QuorumDataType.issue,
        DjangIO.app.models.QuorumDataType.committee,
        DjangIO.app.models.QuorumDataType.press_release,
        DjangIO.app.models.QuorumDataType.tweet,
        DjangIO.app.models.QuorumDataType.facebook_post,
        DjangIO.app.models.QuorumDataType.document,
        DjangIO.app.models.QuorumDataType.note,
        DjangIO.app.models.QuorumDataType.supporter,
        DjangIO.app.models.QuorumDataType.committee_document,
        DjangIO.app.models.QuorumDataType.dc_letter,
        DjangIO.app.models.QuorumDataType.floor_statement,
        DjangIO.app.models.QuorumDataType.caucus,
        DjangIO.app.models.QuorumDataType.amendment,
        DjangIO.app.models.QuorumDataType.user,
        DjangIO.app.models.QuorumDataType.project,
        DjangIO.app.models.QuorumDataType.campaign,
        DjangIO.app.models.QuorumDataType.issue_management,
        DjangIO.app.models.QuorumDataType.alert,
        DjangIO.app.models.QuorumDataType.regulation,
        DjangIO.app.models.QuorumDataType.send_email,
        ...(isFeatureEnabled("ff_regcomment_flv_enabled") ? [DjangIO.app.models.QuorumDataType.reg_comment] : []),
        DjangIO.app.models.QuorumDataType.docket,
        DjangIO.app.models.QuorumDataType.assignment,
    ]

    if (checkPermission(DjangIO.app.models.PermissionType.regulations)) {
        quorumDataTypes.push(DjangIO.app.models.QuorumDataType.regulation)
    }

    quorumDataTypes = quorumDataTypes.filter((item) =>
        permissionFilter(item, { regions: item.supported_regions, useCurrentRegions: true }),
    )

    // sucks but there must be a reason why we want lower caps and special cases
    const strings = quorumDataTypes.map((item) => {
        if (item.value === DjangIO.app.models.QuorumDataType.person.value) {
            return "officials"
        } else if (item.value === DjangIO.app.models.QuorumDataType.facebook_post.value) {
            return "Facebook posts"
        } else if (item.value === DjangIO.app.models.QuorumDataType.dc_letter.value) {
            return item.plural
        } else {
            return item.plural.toLowerCase()
        }
    })

    const placeholders = shuffleArray(strings).slice(0, 3).join(", ")

    if (placeholders.length) {
        return `Search for ${placeholders}, and more...`
    } else {
        return "Search..."
    }
}

export const getPlaceholderForDataType = (qdt) => {
    const docPlaceholders = shuffleArray(DjangIO.app.document.models.DocumentType.region_supported_items())
        .slice(0, 3)
        .map((item) => item.placeholder)
        .join(", ")

    const placeholders = {
        [DjangIO.app.models.QuorumDataType.bill.value]: "Search the titles and full text of bills...",
        [DjangIO.app.models.QuorumDataType.document.value]: `Search for ${docPlaceholders}, and more...`,
        [DjangIO.app.models.QuorumDataType.person.value]: "Search for legislators and executives by name...",
        [DjangIO.app.models.QuorumDataType.staffer.value]: "Search for staffers by name...",
        [DjangIO.app.models.QuorumDataType.supporter.value]: "Search for contacts by name, email...",
        [DjangIO.app.models.QuorumDataType.note.value]: "Search for notes, comments, and interactions...",
        [DjangIO.app.models.QuorumDataType.vote.value]: "Search for votes by name, number...",
        [DjangIO.app.models.QuorumDataType.public_organization.value]: "Search for organizations...",
        [DjangIO.app.models.QuorumDataType.amendment.value]: "Search for amendments...",
        [DjangIO.app.models.QuorumDataType.event.value]:
            "Search for committee meetings, House floor schedules, and legislative sessions...",
        [DjangIO.app.models.QuorumDataType.committee.value]: "Search for committees and subcommittees by name...",
        [DjangIO.app.models.QuorumDataType.caucus.value]: "Search for caucuses by name...",
        [DjangIO.app.models.QuorumDataType.statistic.value]: "Search demographic statistics...",
        [DjangIO.app.models.QuorumDataType.attachment.value]: "Search the names and content of uploaded files...",
        [DjangIO.app.models.QuorumDataType.grassroots_action.value]:
            "Search for grassroots actions by campaign, person, or date...",
        [DjangIO.app.models.QuorumDataType.user.value]: "Search for team members...",
        [DjangIO.app.models.QuorumDataType.project.value]: "Search for projects...",
        [DjangIO.app.models.QuorumDataType.campaign.value]: "Search for campaigns...",
        [DjangIO.app.models.QuorumDataType.issue_management.value]: "Search for issues...",
        [DjangIO.app.models.QuorumDataType.alert.value]: "Search the titles of alerts...",
        [DjangIO.app.models.QuorumDataType.regulation.value]: "Search for regulations by title...",
        [DjangIO.app.models.QuorumDataType.send_email.value]: "Search emails by content...",
        [DjangIO.app.models.QuorumDataType.reply_email.value]: "Search replies by content...",
        [DjangIO.app.models.QuorumDataType.reg_comment.value]: "Search regulation comments by title, author...",
        [DjangIO.app.models.QuorumDataType.docket.value]: "Search dockets by title, description, ID...",
        [DjangIO.app.models.QuorumDataType.assignment.value]:
            "Search assignments by creator or the name/title of the item being assigned...",
        [DjangIO.app.models.QuorumDataType.media.value]: "Search for print, broadcast, and online news articles...",
        [DjangIO.app.models.QuorumDataType.political_committee.value]:
            "Search for candidate committees, PACs, party committees & More...",
        [DjangIO.app.models.QuorumDataType.transaction.value]: "Search for Receipts and Disbursements...",
        [DjangIO.app.models.QuorumDataType.pacc_pac_organization.value]: "Search for PAC Organizations...",
        [DjangIO.app.models.QuorumDataType.pacc_pac_office.value]: "Search for Elected Offices...",
        [DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value]: "Search for Transactions...",
    }

    return placeholders[DjangIO.app.models.QuorumDataType.by_value(qdt).value]
}

export const getFormattedSearchOptionsForDS = (isCommsOnlyUser) => {
    const orderingOptions = getCurrentWebSearchOptions(isCommsOnlyUser)
        .filter((qdt) => qdt.quorumDataType.value !== DjangIO.app.models.QuorumDataType.send_email_archived.value)
        .map((qdt) => {
            // https://itnext.io/using-es6-to-destructure-nested-objects-in-javascript-avoid-undefined-errors-that-break-your-code-612ae67913e9
            const {
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment#Assigning_to_new_variable_names
                label: qdtLabel,
                quorumDataType: { fa5_icon, fa5_icon_family, label, plural, search_description, value },
                uniqueFlvId,
            } = qdt

            const searchIcon = () => {
                switch (value) {
                    case DjangIO.app.models.QuorumDataType.transaction.value:
                        return "money-bill-alt"
                    case DjangIO.app.models.QuorumDataType.political_committee.value:
                        return "dollar-sign"
                    default:
                        return fa5_icon
                }
            }

            // Comms only user/org label change for Documents
            if (qdt.quorumDataType.value === DjangIO.app.models.QuorumDataType.document.value && isCommsOnlyUser) {
                return {
                    fa5_icon_family,
                    fa5_icon: searchIcon(),
                    id: uniqueFlvId,
                    label: "Social Media",
                    path: getSearchPath(qdt),
                    plural: "Social Media",
                    qdtLabel,
                    search_description,
                    value,
                }
            }

            return {
                fa5_icon_family,
                fa5_icon: searchIcon(),
                id: uniqueFlvId,
                label,
                path: getSearchPath(qdt),
                plural,
                qdtLabel,
                search_description,
                value,
            }
        })

    // ensure that the default_search_data_type (usually QuorumDataType.Document for most Personas)
    // is always the first option
    const defaultQdtIndex = orderingOptions.findIndex((option) => option.value === Userdata.default_search_data_type)
    // remove default search data type from the array
    const defaultQdt = orderingOptions.splice(defaultQdtIndex, 1)[0]
    // put default search data type to the front of the array
    orderingOptions.unshift(defaultQdt)

    return orderingOptions
}

/**
 *
 * @returns number - the epoch timestamp one month ago
 */
export const getDateOneMonthAgo = () => {
    const d = new Date()
    return d.setDate(d.getDate() - 30)
}

/**
 * Helper function to display number of a data type selected
 * @name getMessageCountTypeText
 * @function
 * This function takes 1 object of named arguments
 * @param {Number} searchifyCount - count of objects
 * @param {String} selectionTypeSingular - singular name of QDT whose objects we are counting
 * @param {String} selectionTypePlural - plural name of QDT whose objects we are counting
 * @returns String - count and grammatically correct QDT name, examples: 5 Bills or 1 Bill
 */
export const getMessageCountTypeText = (searchifyCount, selectionTypeSingular, selectionTypePlural) => {
    let countTypeText = ""
    if (searchifyCount === 1) {
        countTypeText = selectionTypeSingular
    } else if (searchifyCount > 1 || searchifyCount < 1) {
        countTypeText = selectionTypePlural
    }
    return `${searchifyCount} ${countTypeText} `
}

/**
 * Helper function used with getMessageCountTypeText to get end of sentence
 * @name getMessageEndingText
 * @function
 * This function takes 1 object of named arguments
 * @param {Number} searchifyCount - count of objects
 * @returns String - either "is selected" or "are selected" based on searchifyCount
 */
export const getMessageEndingText = (searchifyCount) => {
    let endingText = ""
    if (searchifyCount === 1) {
        endingText = "is selected"
    } else if (searchifyCount > 1 || searchifyCount < 1) {
        endingText = "are selected"
    }
    return endingText
}

export const getAiSearchExamples = () => {
    // get all available datasets from the regular search and filter it based on the ai search available datasets
    const aiSearchDatasets = [
        DjangIO.app.models.QuorumDataType.bill.plural,
        DjangIO.app.models.QuorumDataType.committee.plural,
        DjangIO.app.models.QuorumDataType.document.plural,
        DjangIO.app.models.QuorumDataType.note.plural,
        DjangIO.app.models.QuorumDataType.person.plural,
        DjangIO.app.models.QuorumDataType.staffer.plural,
        DjangIO.app.models.QuorumDataType.grassroots_action.plural,
        DjangIO.app.models.QuorumDataType.supporter.plural,
    ]
    const regularSearchDatasets = getFormattedSearchOptionsForDS()
    const availableAiSearchDatasets = aiSearchDatasets.filter((qdtPluralLabel) =>
        regularSearchDatasets.some((dataset) => dataset.plural === qdtPluralLabel),
    )

    // get 5 randomized examples, first push all relevant ai search examples
    // then randomize the order and splice the array so that only 5 examples are given
    // examples array will be mutated instead of reassigned
    const examples = []

    for (const qdtPluralLabel of availableAiSearchDatasets) {
        if (aiSearchExamples[qdtPluralLabel]) {
            examples.push(...aiSearchExamples[qdtPluralLabel])
        }
    }

    for (let i = 0; i < examples.length; i++) {
        const randomIndex = Math.floor(Math.random() * i)
        const temp = examples[i]

        examples[i] = examples[randomIndex]
        examples[randomIndex] = temp
    }

    examples.splice(5)

    // returns an object with the available datasets in our current region and the 5 randomized examples
    return {
        datasets: availableAiSearchDatasets,
        examples,
    }
}

/**
 * Converts any `querysetList` filters within initialFilter object
 * from an array of filters to an array of 1 element (combined single filter object)
 * @param {any} obj - any data (preferably an object) to recursively check for `querysetList` within
 */
export const recursiveConvertQuerysetList = (obj) => {
    // base case - ensures that any `obj` argument that is not an object will return the original value
    if (!(obj instanceof Object) || Array.isArray(obj)) return obj

    const newObj = { ...obj }

    // iterate through object's keys
    for (let key of Object.keys(newObj)) {
        if (key === "querysetList") {
            // here is where we recursively check all filters in querysetList for more querysetList(s)
            // combine the filters from querysetList to a single object and set
            newObj[key] = [obj[key].reduce((acc, filter) => ({ ...acc, ...recursiveConvertQuerysetList(filter) }), {})]
        } else {
            // anything that isnt querysetList we recursively check for `querysetList` within
            // base case ensures that any non-objects will exit out immediately
            newObj[key] = recursiveConvertQuerysetList(obj[key])
        }
    }

    return newObj
}
